import { render, staticRenderFns } from "./Crm.vue?vue&type=template&id=d1493622&scoped=true"
import script from "./Crm.vue?vue&type=script&lang=js"
export * from "./Crm.vue?vue&type=script&lang=js"
import style0 from "./Crm.vue?vue&type=style&index=0&id=d1493622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1493622",
  null
  
)

export default component.exports